import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";

const ScrollRestoration = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <Outlet />;
};

export default ScrollRestoration;
